import { Handle, useNodeId } from "reactflow";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton, Typography } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import NodeOptions from "../helper/NodeOptions";
import * as actions from "../../../../../../redux/actions/flowsActions";
import { liveAgentStyles } from "../styles/liveAgentStyles";
import "../styles/node.css";
import "../styles/node-title.css";

const styles = liveAgentStyles;

const LiveAgent = () => {
  const dispatch = useDispatch();
  const nodeId = useNodeId();
  const nodes = useSelector((state) => state.flow?.nodes);
  const title = nodes?.find((node) => node.id === nodeId)?.fieldData?.title;
  const [isHovered, setIsHovered] = useState(false);

  const handleMain = () => {
    dispatch({ type: actions.CURRENT_NODE_ID, payload: { nodeId: nodeId } });
  };

  return (
    <Box
      className="nodeContainer"
      sx={styles.mainContainer}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{ paddingBottom: "10px" }}>
        {isHovered ? (
          <div style={{ paddingLeft: "12px" }}>
            <NodeOptions nodeId={nodeId} nodeType="bot" />
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>
            <Typography
              variant="span"
              sx={{
                fontSize: "13px",
                alignItems: "center",
                fontFamily: "Inter",
                fontWeight: 600,
                color: "#566e8a",
              }}
            >
              {title || "‎"}
            </Typography>
          </div>
        )}
      </div>

      <Box sx={styles.bottomRow}>
        <Handle type="target" position="left" style={styles.leftHandle} />
        <Box sx={styles.nodeBody} onClick={handleMain}>
          <IconButton sx={styles.iconButton}>
            <SupportAgentIcon sx={styles.nodeIcon} />
          </IconButton>
          <Typography variant="span" style={styles.titleName}>
            Live Agent
          </Typography>
          {/* <Handle type="source" position="right" style={styles.rightHandle} /> */}
        </Box>
      </Box>
    </Box>
  );
};

export default LiveAgent;
